import _get from "lodash/get";
import { getInstitution } from './common/general-utils';
import { getNameWithFallbacks } from '../utils';
/**
 * Gets the star rating tooltip
 *
 * @return  {string}                    The star rating tooltip
 */

export var getStarRatingTooltip = function getStarRatingTooltip() {
  return "NerdWallet's ratings are determined by our editorial team. The scoring formula takes into account factors like maximum rates, variety of loan options, visibility of borrower requirements, accessibility, speed of funding, fees and more.";
};
/**
 * Gets Apply Now link urk
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string}                    Apply Now URL
 */

export var getApplyLink = function getApplyLink(marketplaceEntity) {
  return _get(marketplaceEntity, 'derived_details.apply_link.value') || null;
};
/**
 * Gets the alt text for the associated image
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string}                    Alt text
 */

export var getImageAltText = function getImageAltText(marketplaceEntity) {
  return getNameWithFallbacks(marketplaceEntity);
};
/**
 * Gets the source URL for the associated image
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string}                    Image URL
 */

export var getImageSrc = function getImageSrc(marketplaceEntity) {
  return _get(getInstitution(marketplaceEntity), 'details.logo_url.value');
};
/**
 * Get the issuer
 *
 * @param   {Object} marketplaceEntity  The marketplace entity
 * @return  {string}                    Issuer name
 */

export var getIssuerName = function getIssuerName(marketplaceEntity) {
  return _get(getInstitution(marketplaceEntity), 'name') || null;
};
/**
 * Gets the Review link URL
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string}                    Review URL
 */

export var getLearnMoreLink = function getLearnMoreLink(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.review_link.value') || null;
};
/**
 * Gets the Price
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string}                    Review URL
 */

export var getPrice = function getPrice(marketplaceEntity) {
  var result = _get(marketplaceEntity, 'details.price.value');

  return result === undefined || result === null ? null : result;
};
/**
 * Gets the Price Details
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string}                    Review URL
 */

export var getPriceDetails = function getPriceDetails(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.price_details.value') || null;
};
/**
 * Gets the Annual price
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string}                    Review URL
 */

export var getAnnualPrice = function getAnnualPrice(marketplaceEntity) {
  var result = _get(marketplaceEntity, 'details.annual_price.value');

  return result === undefined || result === null ? null : result;
};
/**
 * Gets the Annual price details
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string}                    Review URL
 */

export var getAnnualPriceDetails = function getAnnualPriceDetails(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.annual_price_details.value') || null;
};
/**
 * Gets the Access to attorney support
 *
 * @param   {Object} marketplaceEntity  Marketplace Offer
 *
 * @return  {string}                    Review URL
 */

export var getAccessToAttorneySupport = function getAccessToAttorneySupport(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.access_to_attorney_support.value') ? 'Yes' : 'No';
};